import React from 'react';
import { string, number, func, bool, object, objectOf } from 'prop-types';
import moment from 'moment';
import { keys, join, flattenDeep } from 'lodash';
import CloseIcon from '@material-ui/icons/Close';

import convertGroupIdToLabel from 'helpers/convertGroupIdToLabel';
import { withGroupContext } from 'context/groupContext';

import {
  IconWrapper,
  RemoveButtonWrapper,
  RemoveButton,
  ListItem,
  BulletIcon,
  AnnotationDetails,
  DateAndGroup,
  Text,
  Title,
  Label,
} from './Annotation.style';

function Annotation({
  id,
  groups,
  date,
  title,
  dateRange,
  shortDescription,
  editModeEnabled,
  handleRemoveClick,
  colorById,
}) {
  /**
   * Create a list of attached group ids and default to an empty list. This list
   * of ids is used to show to which groups the annotation is connected.
   */
  const groupIdList = groups
    ? flattenDeep(keys(groups).map(key => groups[key]))
    : [];

  /**
   * Loop over all group ids and convert the id into an user friendly label.
   */
  const groupLabels = groupIdList.map(id => convertGroupIdToLabel(id));
  const dateRangeFrom = moment(dateRange.from * 1000).format('YYYY-MM-DD');
  const dateRangeTo = moment(dateRange.to * 1000).format('YYYY-MM-DD');

  return (
    <ListItem>
      <IconWrapper>
        <BulletIcon />
      </IconWrapper>
      <AnnotationDetails>
        <DateAndGroup>
          {moment(date * 1000).format('YYYY-MM-DD')} - {join(groupLabels, ', ')}
        </DateAndGroup>
        <Label>Date range</Label>
        <Text>{`${dateRangeFrom} - ${dateRangeTo}`}</Text>
        <Label>Title</Label>
        <Title>{title}</Title>
        <Label>Description</Label>
        <Text>{shortDescription}</Text>
      </AnnotationDetails>
      {editModeEnabled && (
        <RemoveButtonWrapper>
          <RemoveButton
            onClick={() => (handleRemoveClick ? handleRemoveClick(id) : null)}
          >
            <CloseIcon />
          </RemoveButton>
        </RemoveButtonWrapper>
      )}
    </ListItem>
  );
}

Annotation.propTypes = {
  id: string.isRequired,
  groups: object.isRequired,
  date: number.isRequired,
  title: string.isRequired,
  shortDescription: string.isRequired,
  editModeEnabled: bool,
  handleRemoveClick: func,
  dateRange: objectOf(number),
};

export default withGroupContext(Annotation);



// WEBPACK FOOTER //
// ./src/components/Annotations/Annotation/Annotation.js